import { servicePurchasesPath } from "@travily/routes";
import type ListingsPurchasesNew from "@travily/types/pages/ListingsPurchasesNew";
import type { ReactNode } from "react";
import { GuestPurchaseFlow } from "@/components/GuestPurchaseFlow";
import { ServicePurchaseNewView } from "./new.view";

const ServicePurchaseNewPage = ({ listing_sqid, free, success }: ListingsPurchasesNew) => (
  <ServicePurchaseNewView>
    <GuestPurchaseFlow free={free} kind="service" path={servicePurchasesPath(listing_sqid)} success={success} />
  </ServicePurchaseNewView>
);

ServicePurchaseNewPage.layout = (page: ReactNode) => page;

export default ServicePurchaseNewPage;
